import { useState } from "react";
import type { ReactNode } from "react";
import { AuthContext } from "./AuthContext";
import { guardarLocalStorage } from "../../shared/utils/funciones";
import { limpiarCacheSesion } from "../../shared/api/cacheSesion";
import { queryClient } from "../../shared/api/queryClient";
import { CONST_KEY_USUARIO_AUTENTICADO } from "../constants/constanst-valores";
import { useNavigate } from "react-router-dom";

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [usuarioAutenticado, setUsuarioAutenticado] = useState<any>(null);

  const navigate = useNavigate();

  const authLogout = () => {
    guardarLocalStorage(null, CONST_KEY_USUARIO_AUTENTICADO);
    // Seguridad: al cerrar sesión se descarta el cache de catálogos en memoria (higiene;
    // el cache ya está aislado por token, pero así no queda data de la sesión anterior).
    limpiarCacheSesion();
    // ítem 15 (guardrail): purga TAMBIÉN la cache de React Query para no filtrar datos de la
    // sesión anterior a la siguiente en la misma pestaña.
    queryClient.clear();
    navigate("/");
  };

  return (
    <AuthContext.Provider
      value={{
        usuarioAutenticado,
        setUsuarioAutenticado,
        authLogout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
